module.exports = "/assets/data/0bd95cc419f3ce22d911a9f617dac538-M34.data.json";